import { NamePath } from "antd/es/form/interface";
import { ZodAny } from "zod";
import { $ZodType } from "zod/v4/core";

export type FieldDef = {
  optional?: boolean;
  nullable?: boolean;
  descr?: string;
};

export const mkField = (
  what: "nullable" | "optional",
  node: { description?: string },
  prevField?: FieldDef,
): FieldDef => ({
  ...prevField,
  [what]: true,
  descr: prevField?.descr ?? node.description,
});

export const makeLabel = (
  node: $ZodType,
  path: NamePath,
  field?: FieldDef,
): string => {
  let label = path[path.length - 1] ?? "";
  if (label === 0) label = "0";
  const descr = (node as ZodAny).description ?? field?.descr;
  if (descr) label += ` (${descr})`;
  return label;
};

/**
 * Особенность Ант-формы состоит в том, что Form.Item внутри Form.List использует для name относительный путь.
 * В то время как Form.useWatch всегда использует полный путь.
 * Поэтому для получения name для Form.Item нужно использовать itemName, а path всегда глобальный.
 * Для получения относительного пути используется тот факт, что Form.List field использует числовое имя.
 */
export const itemName = (path: NamePath): NamePath => {
  let pos = path.length;
  while (pos > 0 && typeof path[--pos] !== "number");
  return path.slice(pos);
};
